import React, {Component} from 'react';
import Header from './Header';
import Products from './Products';
import QuickView from './QuickView';
import Checkout from './Checkout';
import firebase from '../firebase_config';
import CompleteOrder from "./CompleteOrder";
import OrderCompleted from "./OrderCompleted";
import Footer from "./Footer";
import Preloader from "./Preloader";

import it from '../i18n/it.json'
import en from '../i18n/en.json'
import T from 'i18n-react';
import axios from "axios/index";

export default class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            products: [],
            cart: [],
            totalItems: 0,
            totalAmount: 0,
            term: '',
            category: '',
            cartBounce: false,
            quantity: 1,
            quickViewProduct: {},
            modalActive: false,
            userSessionId: null,
            newPostRefOrders: null,
            isOrderConfirmed: false,
            isOrderDone: false,
            isOrderCancelled: false,
            viewCompleteOrder: false,
            locale: localStorage.getItem("locale") ? localStorage.getItem("locale") : 'it',
            emailNotific: false,
            postId: null
        };
        //localStorage.clear();
    }

    generateSession = (ordersInstance) => {
        localStorage.setItem('userSessionId', null);
        const min = 10000;
        const max = 99999;
        const rand = min + Math.random() * (max - min);

        let sessionId = parseInt(rand, 10);

        this.setState({
            userSessionId: sessionId,
            isOrderConfirmed: false,
            isOrderCancelled: false,
            isOrderDone: false,
            cart: [],
            totalAmount: 0,
            totalItems: 0,
            viewCompleteOrder: false,
            newPostRefOrders: null
        }, () => {
            localStorage.setItem('userSessionId', sessionId);
            ordersInstance && this.generateNewOrderRef(ordersInstance);
        });
    };

    getProducts = (products) => {
        this.setState({
            products: products
        });
    };

    generateNewOrderRef = (ordersInstance) => {
        let newPostRefOrders = ordersInstance.push();

        this.setState({
            newPostRefOrders: newPostRefOrders
        });
    };

    componentWillMount() {

        T.setTexts(this.state.locale === 'it' ? it : en);

        this.app = firebase.database().ref('/');

        this.ordersInstance = this.app.child('orders');
        this.productsInstance = this.app.child('products');
        this.subscribersInstance = this.app.child('subscribers');
        this.subscribersDiscountInstance = this.app.child('subscribersDiscount');


        let newPostRefOrders = this.ordersInstance.push();
        //let postId = newPostRefOrders.key;

        this.setState({
            newPostRefOrders: newPostRefOrders
        });

        /** Generation of ID ORDER **/
        let userSessionId = localStorage.getItem("userSessionId");
        !userSessionId ? this.generateSession() : this.setState({userSessionId: userSessionId});

        this.ordersInstance
            .on('value', snapshot => {
                snapshot.forEach((childSnapshot) => {
                    let fbUserSessionId = Object.keys(childSnapshot.val())[0];
                    let userSessionId = localStorage.getItem("userSessionId");
                    if (fbUserSessionId === userSessionId) {

                        console.log("fbUserSessionId: " + fbUserSessionId);
                        console.log("userSessionId: " + userSessionId);

                        let currentOrder = childSnapshot.val()[userSessionId];
                        this.setState({
                            postId: currentOrder.postId,
                            viewCompleteOrder: currentOrder.isPaidCc,
                            isOrderDone: currentOrder.isOrderDone,
                            isOrderConfirmed: currentOrder.isOrderConfirmed,
                            isOrderCancelled: currentOrder.isOrderCancelled
                        });
                    }
                });
            });

        let self = this;

        this.ordersInstance.on('child_changed', snapshot => {
            snapshot.forEach((childSnapshot) => {
                let sn = childSnapshot.val();

                /*console.log("sn.postId: " + sn.postId);
                console.log("userSessionId: " + userSessionId);*/

                if (this.state.postId && this.state.postId === sn.postId) {
                    self.setState({
                        postId: sn.postId,
                        viewCompleteOrder: sn.isPaidCc,
                        isOrderDone: sn.isOrderDone,
                        isOrderConfirmed: sn.isOrderConfirmed
                    });

                    if (sn.isOrderCancelled) {
                        self.setState({
                            userSessionId: null,
                            isOrderConfirmed: false
                        }, () => {
                            self.generateSession();
                        })
                    }
                }
            });
        });

        /** Loading list of products **/
        this.productsInstance.on('value', snapshot => {
            this.getProducts(snapshot.val());
        });
    }

    componentDidMount() {

        /*let userSessionId = localStorage.getItem("userSessionId");
        console.log(userSessionId);*/
    }

    handleMobileSearch = () => {
        this.setState({term: ""});
    };

    // Filter by Category
    handleCategory = (e) => {
        this.setState({category: e.target.value});
    };

    // Add to Cart
    handleAddToCart = (selectedProducts) => {
        let cartItem = this.state.cart;
        let productID = selectedProducts.id;
        let productQty = selectedProducts.quantity;
        if (this.checkProduct(productID)) {
            let index = cartItem.findIndex((x => x.id === productID));
            cartItem[index].quantity = Number(cartItem[index].quantity) + Number(productQty);
            this.setState({
                cart: cartItem
            })
        } else {
            cartItem.push(selectedProducts);
        }
        this.setState({
            cart: cartItem,
            cartBounce: true,
        });
        setTimeout(function () {
            this.setState({
                cartBounce: false,
                quantity: 1
            });
            /*console.log(this.state.quantity);
            console.log(this.state.cart);*/
        }.bind(this), 1000);
        this.sumTotalItems(this.state.cart);
        this.sumTotalAmount(this.state.cart);
    };

    handleRemoveProduct = (id, e) => {
        let cart = this.state.cart;
        let index = cart.findIndex((x => x.id === id));
        cart.splice(index, 1);
        this.setState({
            cart: cart
        });
        this.sumTotalItems(this.state.cart);
        this.sumTotalAmount(this.state.cart);
        e.preventDefault();
    };

    checkProduct = (productID) => {
        let cart = this.state.cart;
        return cart.some(function (item) {
            return item.id === productID;
        });
    };

    sumTotalItems = () => {
        let total;
        let cart = this.state.cart;
        total = cart.length;
        this.setState({
            totalItems: total
        })
    };

    sumTotalAmount = () => {
        let total = 0;
        let cart = this.state.cart;
        for (let i = 0; i < cart.length; i++) {
            total += cart[i].price * parseInt(cart[i].quantity, 10);
        }
        this.setState({
            totalAmount: total
        })
    };

    //Reset Quantity
    updateQuantity = (qty) => {
        //console.log("quantity added...");
        this.setState({
            quantity: qty
        })
    };

    // Open Modal
    openModal = (product) => {
        this.setState({
            quickViewProduct: product,
            modalActive: true
        })
    };

    // Close Modal
    closeModal = () => {
        this.setState({
            modalActive: false
        })
    };

    handleOrderConfirmed = (key) => {

        /*this.setState({
            isOrderConfirmed: true
        }, () => {
            let userSessionId = localStorage.getItem("userSessionId");
            this.ordersInstance
                .child(key)
                .child(userSessionId)
                .update({
                    isOrderConfirmed: true
                });
        });*/

        let userSessionId = localStorage.getItem("userSessionId");
        this.ordersInstance
            .child(key)
            .child(userSessionId)
            .update({
                isOrderConfirmed: true
            });
    };

    handleChangeLocale = e => {
        let locale = e.target.value;
        this.setState({
            locale: locale
        }, () => {
            localStorage.setItem('locale', locale);
            T.setTexts(this.state.locale === 'it' ? it : en);
        });
    };

    handleOrderCompleted = (emailFields) => {
        this.setState({
            emailNotific: true
        }, () => {
            // Sending Email

            let urlSendingEmail = '/send-email.php';
            //let urlSendingEmail = 'http://localhost:80/fuorisalone-webapp/public/send-email.php';
            axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
            axios.defaults.transformRequest = [function (data, headers) {
                let str = [];
                for(let p in data)
                    if (data.hasOwnProperty(p) && data[p]) {
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(data[p]));
                    }
                return str.join("&");
            }];
            axios({
                method: 'post',
                url: urlSendingEmail,
                data: emailFields,
            })
                .then((r) => {
                    console.log(r);
                })
                .catch((error) => {
                    console.log(error);
                });
        })
    };

    handleNewOrder = (ordersInstance) => {
        this.generateSession(ordersInstance);
    };

    handleCancelledOrder = () => {
        this.setState({
            isOrderCancelled: false
        })
    }

    render() {
        let visibleView = '';

        if (this.state.isOrderConfirmed && !this.state.viewCompleteOrder && !this.state.isOrderCancelled) {
            if (this.state.products.length === 0) {
                visibleView = <Preloader/>
            } else {
                window.scrollTo(0, 0);
                visibleView = (
                    <div className="products-wrapper">
                        <Checkout userSessionId={this.state.userSessionId} checkoutModal={this.state.checkoutModal}/>
                    </div>
                )
            }
        } else if (this.state.viewCompleteOrder && !this.state.isOrderDone && this.state.products.length > 0) {
            if (this.state.products.length === 0) {
                visibleView = <Preloader/>
            } else {
                visibleView = (
                    <CompleteOrder
                        ordersInstance={this.ordersInstance}
                        postId={this.state.postId}
                        userSessionId={this.state.userSessionId}
                        handleOrderCompleted={this.handleOrderCompleted}
                        locale={this.state.locale}
                    />
                )
            }
        } else if (this.state.isOrderConfirmed && this.state.isOrderDone && this.state.viewCompleteOrder) {
            if (this.state.products.length === 0) {
                visibleView = <Preloader/>
            } else {
                window.scrollTo(0, 0);
                visibleView = <OrderCompleted
                    userSessionId={this.state.userSessionId}
                    emailNotific={this.state.emailNotific}
                    ordersInstance={this.ordersInstance}
                    handleNewOrder={this.handleNewOrder}/>
            }

        } else {
            visibleView = (
                <Products
                    cartItems={this.state.cart}
                    productsList={this.state.products}
                    searchTerm={this.state.term}
                    addToCart={this.handleAddToCart}
                    productQuantity={this.state.quantity}
                    updateQuantity={this.updateQuantity}
                    openModal={this.openModal}
                    subscribersDiscountInstance={this.subscribersDiscountInstance}
                    locale={this.state.locale}
                    isOrderConfirmed={this.state.isOrderConfirmed}
                    isOrderDone={this.state.isOrderDone}
                    viewCompleteOrder={this.state.viewCompleteOrder}
                />
            )
        }

        return (
            <div>
                <div className="shipping-alert">{T.translate("labels.shippingAlert")}</div>
                <Header
                    locale={this.state.locale}
                    handleChangeLocale={this.handleChangeLocale}
                    cartBounce={this.state.cartBounce}
                    total={this.state.totalAmount}
                    totalItems={this.state.totalItems}
                    cartItems={this.state.cart}
                    removeProduct={this.handleRemoveProduct}
                    handleSearch={this.handleSearch}
                    handleMobileSearch={this.handleMobileSearch}
                    handleCategory={this.handleCategory}
                    categoryTerm={this.state.category}
                    updateQuantity={this.updateQuantity}
                    productQuantity={this.state.quantity}
                    handleOrderConfirmed={this.handleOrderConfirmed}
                    isOrderConfirmed={this.state.isOrderConfirmed}
                    isOrderCancelled={this.state.isOrderCancelled}
                    isOrderDone={this.state.isOrderDone}
                    ordersInstance={this.ordersInstance}
                    productsInstance={this.productsInstance}
                    newPostRefOrders={this.state.newPostRefOrders}
                    postId={this.state.postId}
                    viewCompleteOrder={this.state.viewCompleteOrder}
                    handleCancelledOrder={this.handleCancelledOrder}
                />
                {visibleView}
                {
                    (!this.state.isOrderConfirmed && !this.state.isOrderDone) &&
                    <QuickView
                        product={this.state.quickViewProduct}
                        cartItems={this.state.cart}
                        openModal={this.state.modalActive}
                        addToCart={this.handleAddToCart}
                        productQuantity={this.state.quantity}
                        closeModal={this.closeModal}
                        updateQuantity={this.updateQuantity}
                        subscribersInstance={this.subscribersInstance}
                        locale={this.state.locale}
                    />
                }
                {
                    this.state.products.length > 0 &&
                    <Footer isOrderConfirmed={this.state.isOrderConfirmed}
                            viewCompleteOrder={this.state.viewCompleteOrder}
                            isOrderCancelled={this.state.isOrderCancelled}
                            isOrderDone={this.state.isOrderDone}
                    />
                }

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Home.js